import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAutomationTemplateDraftStateQuery } from '../../queries/useAutomationTemplateHasDraftQuery';
import { invalidateAutomationTemplateQuery } from '../../queries/useAutomationTemplateQuery';

interface Params {
	templateId: string;
	stepId: string;
	caseIds: string[];
	impersonationContext?: Api.IImpersonationContext;
	relatedTemplateIds?: string[];
}

export function useAutomationTemplateStepSwitchReorderCasesMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISwitchAutomationStep, variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ templateId, stepId, caseIds, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.ISwitchAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Switch/${encodeURIComponent(
						stepId
					)}/CaseOrder`,
					impersonationContext,
				}),
				'PUT',
				caseIds
			);
		},
		onError,
		onSuccess: (data, variables) => {
			const templateIdsToInvalidate = new Set([variables.templateId, ...(variables.relatedTemplateIds ?? [])]);
			for (const templateId of templateIdsToInvalidate) {
				invalidateAutomationTemplateQuery(templateId);
				invalidateAutomationTemplateDraftStateQuery(templateId);
			}
			onSuccess?.(data, variables);
		},
	});
}
